import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { get, action } from '@ember/object';
import { getUnixTime, addSeconds, addMinutes, startOfDay } from 'date-fns';
import catchServiceError from 'garaje/utils/catch-service-error';
import { SECONDS_IN_A_DAY } from 'garaje/utils/enums';

export default class MapsRoute extends Route {
  title = 'Maps · Envoy';

  @service state;
  @service store;
  @service abilities;
  @service metrics;
  @service router;
  @service ajax;
  @service featureFlags;

  beforeModel() {
    if (this.abilities.cannot('visit-maps-nav maps')) {
      this.router.transitionTo('unauthorized');
    }
  }

  async model() {
    const { currentLocation } = this.state;
    const currentLocationId = currentLocation.id;
    const areaMaps = await this.store.query('area-map', {
      filter: { location: currentLocationId },
      include: 'map-floors',
    });
    let areaMap = areaMaps.slice()[0];

    // Create a new area map if one doesn't exist
    // This should be removed once the backend initializes db with area-map for locations with a desk subscription
    if (!areaMap) {
      areaMap = await this.store.createRecord('area-map', { entityId: currentLocationId }).save();
    }

    const startOfLocationDay = addMinutes(startOfDay(new Date()), this.state.minutesBetweenTimezones());
    const filter = {
      'location-id': currentLocationId,
      'user-id': this.state.currentUser.id,
      'start-date': getUnixTime(startOfLocationDay),
      'end-date': getUnixTime(addSeconds(startOfLocationDay, SECONDS_IN_A_DAY - 1)),
    };
    // Optional: only preselects the floor of the user's reservation. Degrade
    // instead of taking down the whole Maps section when envoy-spaces is down.
    const currentUserReservations = (
      await catchServiceError(this.store.query('reservation', { filter, include: 'desk' }), [], {
        event: 'MAPS_ROUTE_RESERVATIONS_DEGRADED',
        metrics: this.metrics,
      })
    ).slice();
    let currentUserReservationMapFloor = null;
    if (currentUserReservations[0]) {
      const currentUserRes = currentUserReservations[0];
      const currentUserReservationFloor = await get(currentUserRes, 'desk.floor');
      currentUserReservationMapFloor = this.store.peekRecord('map-floor', currentUserReservationFloor.id);
    }

    return { areaMap, currentUserReservationMapFloor };
  }

  @action
  refreshMapsRoute() {
    this.refresh();
  }
}
